import {Pipe, PipeTransform} from "@angular/core";
import {dateWithoutTime} from "../date-functions";

@Pipe({
    name: 'dateAmountSince',
    standalone: false
})
export class DateAmountSincePipe implements PipeTransform {

	transform(dateInPast: Date | string): string {
		if (dateInPast == null) {
			return '';
		}

		dateInPast = dateWithoutTime(dateInPast);
		const daysPassed = Math.round((new Date().getTime() - dateInPast.getTime()) / (1000 * 60 * 60 * 24));

		if (daysPassed < 1) {
			return 'today';
		} else if (daysPassed === 1) {
			return 'yesterday';
		} else if (daysPassed < 7) {
			return daysPassed + ' days ago';
		} else if (daysPassed < 31) {
			const weeks = this.getWeeks(daysPassed);
			return weeks === 1 ? (weeks + ' week ago') : (weeks + ' weeks ago');
		} else if (daysPassed < 365) {
			const months = this.getMonths(daysPassed);
			return months === 1 ? (months + ' month ago') : (months + ' months ago');
		} else {
			const years = this.getYears(daysPassed);
			return years === 1 ? (years + ' year ago') : (years + 'years ago');
		}
	}

	private getWeeks(daysPassed: number): number {
		return Math.round(daysPassed / 7);
	}

	private getMonths(daysPassed: number): number {
		return Math.round(daysPassed / 30);
	}

	private getYears(daysPassed: number): number {
		return Math.floor(daysPassed / 365);
	}
}
